import { Col, DatePicker, Form, Input, Radio, Row, Select } from "antd";
import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { InitialData } from "../../common/InitialData";
import dayjs from "dayjs";
import { convertObject, reverseObject } from "../../common/Utilities";

const Declaration = ({ loanDetails }) => {
  const [declarationDetails, setDeclarationDetails] = useState({
    ...InitialData.applicant_declaration,
    declaration_date: dayjs(new Date()),
  });
  const [validationDetails, setValidationDetails] = useState({});


  useEffect(() => {
    const savedValues = localStorage.getItem("declarationDetails");
    if (savedValues) {
      const parsedValues = JSON.parse(savedValues);
      const reversedValues = reverseObject(parsedValues); // if you use your reverseObject utility
      setDeclarationDetails(reversedValues);
      setValidationDetails(parsedValues);
    }
  }, []);

  //get form data
  // const firstProduct =
  //   products?.Bank ||
  //   products?.["Financial_Institution"] ||
  //   products?.["In-House"];
  const parsedData = loanDetails?.products?.Bank?.map((bank) => {
    try {
      const parsedFormData = JSON.parse(bank.form_data);

      localStorage.setItem("declaration_formdata", JSON.stringify(parsedFormData));
      return {
        ...bank,
        parsedFormData,
      };
    } catch (e) {
      console.error(`Error parsing form_data for ${bank.name}`, e);
      return {
        ...bank,
        parsedFormData: null,
      };
    }
  });

  const validateField = (field, value) => {
    if (!field.required) return undefined;

    switch (field.element) {
      case "TextInput":
      case "Dropdown":
      case "RadioButtons":
        if (!value) return `This field is required`;
        break;
      case "Checkboxes":
        if (!value || value.length === 0) return `This field is required`;
        break;
      default:
        return undefined;
    }
    return undefined;
  };

  const saveToLocalStorage = (formikValues) => {
    const converted = convertObject(formikValues);
    localStorage.setItem("declarationDetails", JSON.stringify(converted));
    setValidationDetails(converted);
  };

  return (
    <div className="mx-5">
      <Formik enableReinitialize={true} initialValues={declarationDetails}>
        {(formikProps) => (
          <Form layout="vertical" style={{ minHeight: "600px" }}>
            <div className="input-one-line-dealer">
              <div className="input-group w-full md:w-[230px]">
                {/* Declaration Date */}
                <Form.Item name="declaration_date" className="mt-1 w-full">
                  <label>Declaration Date</label>
                  <DatePicker
                    className="py-[8px] w-full md:w-[230px]"
                    placeholder="DD-MM-YYYY"
                    allowClear={false}
                    format="DD-MM-YYYY"
                    value={
                      formikProps.values.declaration_date
                        ? dayjs(formikProps.values.declaration_date)
                        : null
                    }
                    onChange={(date) => {
                      const formattedDate = dayjs(date).format("YYYY-MM-DD");
                      formikProps.setFieldValue("declaration_date", formattedDate);
                      saveToLocalStorage({ ...formikProps.values, declaration_date: formattedDate });
                    }}
                  />
                  {validationDetails?.declaration_date?.validation === false && (
                    <span className="error">Declaration Date Required</span>
                  )}
                </Form.Item>

                {/* Dynamic Fields */}
                {parsedData?.map((bank) => (
                  <div className="pt-5" key={bank.name}>
                    {bank.parsedFormData?.map((field) => (
                      <div className="input-group" key={field.id}>
                        {/* Header */}
                        {field.element === "Header" && (
                          <div className="input-label">
                            <label
                              style={{
                                fontWeight: field.bold ? "bold" : "normal",
                                fontStyle: field.italic ? "italic" : "normal",
                              }}
                              dangerouslySetInnerHTML={{ __html: field.content || "" }}
                            />
                          </div>
                        )}

                        {/* Text Input */}
                        {field.element === "TextInput" && (
                          <Form.Item name={field.field_name} className="mt-1 w-full">
                            <label
                              dangerouslySetInnerHTML={{
                                __html:
                                  (field.label || field.text || "") +
                                  (field.required ? ' <span style="color:red">*</span>' : ""),
                              }}
                            />
                            <Input
                              value={formikProps.values[field.field_name] || ""}
                              placeholder="Enter value"
                              className="input-w-common"
                              onChange={(e) => {
                                formikProps.setFieldValue(field.field_name, e.target.value);
                                saveToLocalStorage({
                                  ...formikProps.values,
                                  [field.field_name]: e.target.value,
                                });
                              }}
                            />
                            {validateField(field, formikProps.values[field.field_name]) && (
                              <span
                                className="error"
                                dangerouslySetInnerHTML={{
                                  __html: validateField(field, formikProps.values[field.field_name]),
                                }}
                              />
                            )}
                          </Form.Item>
                        )}

                        {/* Dropdown */}
                        {field.element === "Dropdown" && (
                          <Form.Item name={field.field_name} className="mt-1 w-full">
                            <label
                              dangerouslySetInnerHTML={{
                                __html:
                                  (field.label || field.text || "") +
                                  (field.required ? ' <span style="color:red">*</span>' : ""),
                              }}
                            />
                            <Select
                              value={formikProps.values[field.field_name] || undefined}
                              onChange={(val) => {
                                formikProps.setFieldValue(field.field_name, val);
                                saveToLocalStorage({
                                  ...formikProps.values,
                                  [field.field_name]: val,
                                });
                              }}
                              className="input-w-common"
                              placeholder="Select an option"
                            >
                              {field.options?.map((opt) => (
                                <Select.Option key={opt.key} value={opt.value}>
                                  <span dangerouslySetInnerHTML={{ __html: opt.text }} />
                                </Select.Option>
                              ))}
                            </Select>
                            {validateField(field, formikProps.values[field.field_name]) && (
                              <span
                                className="error"
                                dangerouslySetInnerHTML={{
                                  __html: validateField(field, formikProps.values[field.field_name]),
                                }}
                              />
                            )}
                          </Form.Item>
                        )}

                        {/* Radio Buttons */}
                        {field.element === "RadioButtons" && (
                          <Form.Item name={field.field_name} className="mt-1 w-full">
                            <label
                              dangerouslySetInnerHTML={{
                                __html:
                                  (field.label || field.text || "") +
                                  (field.required ? ' <span style="color:red">*</span>' : ""),
                              }}
                            />
                            <Radio.Group
                              value={formikProps.values[field.field_name] || ""}
                              onChange={(e) => {
                                formikProps.setFieldValue(field.field_name, e.target.value);
                                saveToLocalStorage({
                                  ...formikProps.values,
                                  [field.field_name]: e.target.value,
                                });
                              }}
                              style={{
                                display: field.canHaveDisplayHorizontal ? "flex" : "block",
                                gap: field.canHaveDisplayHorizontal ? "16px" : "0px",
                              }}
                            >
                              {field.options?.map((opt) => (
                                <Radio key={opt.key} value={opt.value}>
                                  <span dangerouslySetInnerHTML={{ __html: opt.text }} />
                                </Radio>
                              ))}
                            </Radio.Group>
                            {validateField(field, formikProps.values[field.field_name]) && (
                              <span
                                className="error"
                                dangerouslySetInnerHTML={{
                                  __html: validateField(field, formikProps.values[field.field_name]),
                                }}
                              />
                            )}
                          </Form.Item>
                        )}

                        {/* Checkboxes */}
                        {field.element === "Checkboxes" && (
                          <Form.Item name={field.field_name} className="mt-1 w-full">
                            <label
                              dangerouslySetInnerHTML={{
                                __html:
                                  (field.label || field.text || "") +
                                  (field.required ? ' <span style="color:red">*</span>' : ""),
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                alignItems: "center",
                              }}
                            >
                              {field.options?.map((opt) => (
                                <label
                                  key={opt.key}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={(formikProps.values[field.field_name] || []).includes(opt.value)}
                                    onChange={(e) => {
                                      const oldVal = formikProps.values[field.field_name] || [];
                                      const newVal = e.target.checked
                                        ? [...oldVal, opt.value]
                                        : oldVal.filter((v) => v !== opt.value);
                                      formikProps.setFieldValue(field.field_name, newVal);
                                      saveToLocalStorage({
                                        ...formikProps.values,
                                        [field.field_name]: newVal,
                                      });
                                    }}
                                  />
                                  <span dangerouslySetInnerHTML={{ __html: opt.text }} />
                                </label>
                              ))}
                            </div>
                            {validateField(field, formikProps.values[field.field_name]) && (
                              <span
                                className="error"
                                dangerouslySetInnerHTML={{
                                  __html: validateField(field, formikProps.values[field.field_name]),
                                }}
                              />
                            )}
                          </Form.Item>
                        )}
                      </div>
                    ))}
                  </div>
                ))}

              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Declaration;